import Check from '@lt/components/icons-react/rebrand/DoneMark';
import { useTranslation } from '@lt/localization';
import React from 'react';
import styles from './alreadySeenLabel.module.css';

const AlreadySeenLabel: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.label}>
      <Check className={styles.checkIcon} />
      <span>{t('hotelcard.card.label')}</span>
    </div>
  );
};

export default AlreadySeenLabel;
